<template>
  <div class="ultrasound component component--fullscreen" v-if="visable">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>
    <transition name="containter">
      <div class="component__containter" v-if="componentVisible">
        <div class="header">
          <div class="title">{{ $t('ultrasound.title') }}</div>
          <div class="caption">{{ $t('ultrasound.desc') }}</div>
          <button class="toggle" v-on:click="toggleUltrasound()"><i class="material-icons">close</i></button>
        </div>
        <div class="body">
          <div class="tap-to-play" v-if="!ultrasoundPlaying">
            <i class="material-icons">play_arrow</i>
            <div class="label">{{ $t('ultrasound.play') }}</div>
          </div>
          <div class="player" v-else>
            <i class="material-icons">tap_and_play</i>
            <div class="wave"></div>
            <div class="wave"></div>
            <div class="wave"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Ultrasound',
  props: {
    visable: {
      type: Boolean,
      required: true,
    },
    ultrasoundPlaying: {
      required: true,
    },
  },
  data() {
    return {
      componentVisible: false,
    };
  },
  computed: {
    ...mapState([
      'card',
    ]),
  },
  watch: {
    visable(value) {
      this.$nextTick(() => {
        this.componentVisible = value;
      });
    },
  },
  mounted() {
    if ('soundcode' in this.$route.query) {
      this.$emit('toggleUltrasound');
    }
  },
  methods: {
    toggleUltrasound() {
      this.$emit('toggleUltrasound');
    },
  },
};
</script>

<style lang="sass" scoped>
.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  align-items: center
  z-index: 1040

  transition: all .25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__containter
  position: relative
  width: 100vw
  box-shadow: 0 0 9px 0 rgba(0, 0, 0, .5)
  overflow: hidden
  z-index: 1050
  margin: 0 auto

  border-radius: 10px

  background-color: #ffea00

  @media only screen and (min-width : 768px)
    max-width: 475px

.header
  position: relative
  padding: 10px

  background-color: white
  text-align: center

.title
  font-size: 1rem
  font-weight: bold
  color: #333

.caption
  margin: 0 7%
  font-size: 0.75rem
  font-weight: bold
  color: #A6A6A6

.toggle
  position: absolute
  top: 0
  right: 0
  bottom: 0

  border: none

  background: none

  -webkit-appearance: none
  cursor: pointer

  &:active
    opacity: .9

    outline: none

  .material-icons
    padding: 6px

.body
  padding: 30px

  text-align: center

.tap-to-play
  position: relative
  width: 300px
  height: 300px
  margin: 0 auto

  .material-icons
    position: absolute
    top: 50%
    left: 50%
    width: 100px
    height: 100px

    border-radius: 50%

    background-color: #333

    font-size: 4.5rem
    line-height: 100px
    color: #ffea00

    transform: translate(-50%, -70%)

  .label
    position: absolute
    bottom: 27.5%
    left: 0
    right: 0
    width: 100%
    opacity: .75

    text-align: center
    font-weight: bold
    font-size: 0.875rem
    color: #333

.player
  position: relative
  width: 300px
  height: 300px
  margin: 0 auto

  .material-icons
    position: absolute
    top: 50%
    left: 50%
    z-index: 2

    font-size: 4.5rem
    color: rgba(0, 0, 0, .75)

    transform: translate(-50%, -50%)
    animation-duration: 2s
    animation-name: icon
    animation-iteration-count: infinite
    animation-timing-function: ease-in-out

@keyframes icon
  0%
    transform: translate(-50%, -45%)
  50%
    transform: translate(-50%, -55%)
  100%
    transform: translate(-50%, -45%)

.wave
  position: absolute
  top: 50%
  left: 50%
  width: 100%
  height: 100%
  opacity: 0

  background: white
  border-radius: 50%

  transform: translate(-50%, -50%) scale(0.3)
  transform-origin: 50% 50%
  animation-duration: 3s
  animation-name: radio
  animation-iteration-count: infinite

  &:nth-child(2)
    animation-delay: 1000ms

  &:nth-child(3)
    animation-delay: 2000ms

@keyframes radio
  0%
    transform: translate(-50%, -50%) scale(0.7)
    opacity: 0
  10%
    transform: translate(-50%, -50%) scale(0.6)
    opacity: 1
  100%
    transform: translate(-50%, -50%) scale(1)
    opacity: 0

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.containter-enter-active,
.containter-leave-active
  transition: opacity .25s cubic-bezier(0, 0, .2, 1), transform .15s cubic-bezier(0, 0, .2, 1)

.containter-enter,
.containter-leave-to
  opacity: 0
  transform: translateY(150px) scale(.8)
</style>
